module.exports = __webpack_public_path__ + "static/media/007_imagedetail_viewer.6fe7529c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/vmware/007_imagedetail_viewer.png
// module id = 640
// module chunks = 0